// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-libs_core_src_lib_services_date_date_service_ts-libs_core_src_lib_tokens_unleash-flag-8d7a3b":"a0e2093465799841","libs_wl_westpac_src_lib_gift-card_gift-card-wrapper_module_ts":"77cc70c379366680","apps_bsa_src_app_offer_offer-wrapper_module_ts":"d7a83f653b18467a"}[chunkId] + ".js";
};